import BubbleCommon from '@op/components/BubbleCommon';
import { METRICS_KEY_ZERO_NO_RATIO } from '@op/pages/Compare/Compare/constant';
import { getRationPercentValue } from '@op/utils';
import React from 'react';
import * as KeywordURLDrillTips from '@op/components/BubbleCommon/copywritingKey/keywordDrillUrl';

export const dealWithKeywordDrillStats = ({ data, filter }) => {
  const { new_list, old_list, ...resData } = data;
  const keys = Object.keys(new_list);
  let isEmpty = 0;
  // if (Array.isArray(filter?.channel) && filter?.channel?.includes('steam')) {
  //   const steamList = new_list?.steam;
  //   const oldSteamList = old_list?.steam;
  //   const steamKeys = steamList?.map((val) => val.key);
  //   const steamValueMap = steamList?.reduce((pre, val) => {
  //     const keyPrefix = `steam_${val.key}`;

  //     Object.entries(val).forEach(([key, value]) => {
  //       if (key === 'key') return;
  //       const newKey = key === 'review' ? keyPrefix : `${keyPrefix}_${key}`;
  //       pre[newKey] = value;
  //     });

  //     return pre;
  //   }, {});

  //   const oldSteamValueMap = oldSteamList?.reduce((pre, val) => {
  //     const keyPrefix = `steam_${val.key}`;

  //     Object.entries(val).forEach(([key, value]) => {
  //       if (key === 'key') return;
  //       const newKey = key === 'review' ? keyPrefix : `${keyPrefix}_${key}`;
  //       pre[`${newKey}_old`] = value;
  //     });

  //     return pre;
  //   }, {});

  //   const finalList = steamKeys?.reduce((pre, key) => {
  //     const newKey = `steam_${key}`;
  //     const oldKey = `${newKey}_old`;
  //     const ratioKey = `${newKey}_ratio`;
  //     const value = steamValueMap?.[newKey] || 0;
  //     const oldValue = oldSteamValueMap?.[oldKey] || 0;
  //     let ratio = getRationPercentValue(value, oldValue, 6);

  //     if (
  //       (value === 0 || oldValue === 0) &&
  //       METRICS_KEY_ZERO_NO_RATIO.includes(key)
  //     ) {
  //       ratio = 0;
  //     }
  //     if (!isNaN(Number(value)) && Number(value) !== 0) {
  //       isEmpty += 1;
  //     }
  //     return { ...pre, [newKey]: value, [oldKey]: oldValue, [ratioKey]: ratio };
  //   }, {});
  //   extraList = { ...steamValueMap, ...oldSteamValueMap, ...finalList };
  // }

  const valueMap = keys.reduce((pre, key) => {
    const oldKey = `${key}_old`;
    const ratioKey = `${key}_ratio`;
    const value = new_list?.[key] || 0;
    const oldValue = old_list?.[key] || 0;
    let ratio = getRationPercentValue(value, oldValue, 6);

    if (
      (value === 0 || oldValue === 0) &&
      METRICS_KEY_ZERO_NO_RATIO.includes(key)
    ) {
      ratio = 0;
    }
    if (!isNaN(Number(value)) && Number(value) !== 0) {
      isEmpty += 1;
    }
    return { ...pre, [key]: value, [oldKey]: oldValue, [ratioKey]: ratio };
  }, {});

  return {
    ...valueMap,
    ...resData,
    empty: isEmpty === 0,
  };
};

export const chartTitle = ({
  formatMessage,
  title,
  titleTipsKey,
  ...restProps
}: {
  formatMessage: any;
  title?: string;
  titleTipsKey?: string;
}) => {
  if (!title) return undefined;

  // @ts-ignore
  const tipsMap = KeywordURLDrillTips?.[titleTipsKey] || undefined;

  if (!tipsMap) {
    return formatMessage({ id: title });
  }

  return (
    <BubbleCommon tipsMap={tipsMap} showIcon={true} {...restProps}>
      {formatMessage({ id: title })}
    </BubbleCommon>
  );
};
